export default __webpack_public_path__ + "media/images/icons_fc/note-f7c6a9dfd9d16fb232aba7e5eba126a9.png";